import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CompleteNotification, Notification } from "../../types/types.notifications";

// Define the initial state using that type
const initialState: CompleteNotification = {
    Notification: [],
    CurrentPath: ''
}

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        pushNotification: (state, action: PayloadAction<Notification>) => {
            state.Notification.push(action.payload)
        },
        setCurrentPath: (state, action: PayloadAction<string>) => {
            state.CurrentPath = action.payload
        },
        deleteNotification: (state, action: PayloadAction<string>) => {
            state.Notification = state.Notification.filter(x=>x.Id !== action.payload)
        },
        deleteNotificated: (state, action: PayloadAction<string>) => {
            const item = state.Notification.find(x=>x.Id === action.payload)
            if(item){
                item.State = 'viewed'
            }
        },
        clearAllNotifications: (state) => {
            state.CurrentPath = ''
            state.Notification =[]
        },
    }
})

export const { pushNotification, setCurrentPath, deleteNotification, deleteNotificated, clearAllNotifications} = notificationsSlice.actions;